module.exports = __webpack_public_path__ + "static/media/linkedin.a242cd88.svg";